<template>
	<div class="toast-container position-fixed bottom-0 end-0 p-2" style="z-index: 1152">
		<div
			v-for="toast in toasts"
			:key="toast.id"
			:class="`${getBgColor(toast.variant)} ${getTextColor(toast.variant)} ${getBorderColor(toast.variant)}`"
			aria-atomic="true"
			aria-live="assertive"
			class="toast align-items-center show"
			role="alert"
		>
			<div  class="d-flex w-100" v-if="toast.heading">
				<strong class="toast-header text-dark text-capitalize w-100 pe-4">{{ toast.heading }}</strong>
				<button
					aria-label="Close"
					class="btn-close me-2 m-auto btn-close-dark position-absolute" style="top: 14px; right: 6px;"
					type="button"
					@click="removeToast(toast.id)"
				></button>
			</div>
			<div class="d-flex w-100">
				<div class="toast-body">{{ toast.message }}</div>
				<button v-if="!toast.heading"
					aria-label="Close"
					class="btn-close me-2 m-auto"
					:class="closeBtnColor(toast.variant)"
					type="button"
					@click="removeToast(toast.id)"
				></button>
			</div>
		</div>
	</div>

</template>

<script setup>
import { storeToRefs } from "pinia";
import { useToastStore } from '../stores/toast-store';

const toastStore = useToastStore();
const { toasts } = storeToRefs(toastStore);
const { removeToast } = toastStore;

const getTextColor = (variant) => {
	switch (variant) {
		case "success":
		case "danger":
		case "info":
		case "warning":
			return "text-white";
		default:
			return "text-dark";
	}
};

const getBgColor = (variant) => {
	switch (variant) {
		case "success":
			return "bg-success border-0";
		case "danger":
			return "bg-danger border-0";
		case "info":
			return "bg-info border-0";
		case "warning":
			return "bg-warning border-0";
		default:
			return "bg-light";
	}
};

const getBorderColor = (variant) => {
	switch (variant) {
		case "outline-success":
			return "toast-outline-success";
		case "outline-danger":
			return "toast-outline-danger";
		case "outline-info":
			return "toast-outline-info";
		case "outline-warning":
			return "toast-outline-warning";
		default:
			return "";
	}
}

const closeBtnColor = (variant) => {
	switch (variant) {
		case "success":
		case "danger":
		case "info":
		case "warning":
			return "btn-close-white";
		default:
			return "btn-close-dark";
	}
};

</script>


<style lang="scss" scoped>
.toast-container {
	max-width: 350px;
}
.toast-outline-danger {
	border-left: 5px solid #dc3545;
}
.toast-outline-success{
	border-left: 5px solid #198754;
}
.toast-outline-warning {
	border-left: 5px solid #fd7e14;
}
.toast-outline-info {
	border-left: 5px solid #0dcaf0;
}
</style>